import * as React from 'react';
import { useState } from 'react';

const ShowMoreLess = (props) => {
    const { single_product, no_show_more } = props;
    const [action_here, set_action_here] = useState('more');
    const defaultDescLength = 100;
    let shortDescription = single_product.ShortDescription !== undefined && single_product.ShortDescription !== null ? (single_product.ShortDescription.length > defaultDescLength ? single_product.ShortDescription.substring(0, defaultDescLength) : single_product.ShortDescription) : '';

    return (
        <>
            {action_here === 'more' && single_product && shortDescription != '' && (single_product.ShortDescription !== undefined && single_product.ShortDescription !== null && single_product.ShortDescription.trim() !== '' && single_product.ShortDescription.length > defaultDescLength) && no_show_more === undefined
                ?
                <p className="mob-font-13">{shortDescription}<a
                    onClick={(e) => {
                        e.stopPropagation();
                        set_action_here('less')
                    }}
                    className="more-link"> …
                    More</a>
                </p> : <p className="mob-font-13">{single_product.ShortDescription}</p>}
        </>
    );

};

export default ShowMoreLess;